export default "__VITE_ASSET__37qhjKwk__"